import { useAuthenticationStore } from "@/stores/authentication"
import { useCommonStore } from "@/stores/common"
import { useDateFilterConsumptionStore } from "@/stores/consumption"
import { useContactStore } from "@/stores/contact"
import { useContractStore } from "@/stores/contract"
import { useCostCenterStore } from "@/stores/costCenter"
import { useCustomerStore } from "@/stores/customer"
import { useInvoiceSituationStore } from "@/stores/invoiceSituation"
import { useInvoicingStore } from "@/stores/invoicing"
import { useListsStore } from "@/stores/lists"
import { useNewOrderStore } from "@/stores/newOrder"
import { useProductStore } from "@/stores/product"
import { usePromotionStore } from "@/stores/promotion"
import { useRecoveryStore } from "@/stores/recovery"
import { useSettingStore } from "@/stores/setting"

export const initStores = () => {
    const authStore = useAuthenticationStore()
    const commonStore = useCommonStore()
    const consumptionStore = useDateFilterConsumptionStore()
    const contactStore = useContactStore()
    const contractStore = useContractStore()
    const costCenterStore = useCostCenterStore()
    const customerStore = useCustomerStore()
    const invoiceSituationStore = useInvoiceSituationStore()
    const invoicingStore = useInvoicingStore()
    const listStore = useListsStore()
    const newOrderStore = useNewOrderStore()
    const productStore = useProductStore()
    const promotionStore = usePromotionStore()
    const recoveryStore = useRecoveryStore()
    const settingStore = useSettingStore() 

    return {
        authStore: authStore,
        commonStore: commonStore,
        consumptionStore: consumptionStore,
        contactStore: contactStore,
        contractStore: contractStore,
        costCenterStore: costCenterStore,
        customerStore: customerStore,
        invoiceSituationStore: invoiceSituationStore,
        invoicingStore: invoicingStore,
        listStore: listStore,
        newOrderStore: newOrderStore,
        productStore: productStore,
        promotionStore: promotionStore,
        recoveryStore: recoveryStore,
        settingStore: settingStore,
    }
}